import { useParams } from "react-router-dom";
import { EmployeeCell } from "components/cell/employee/cell";
import Loader from "@/components/loader";
import { useBestPerformers } from "./useBestPerformers";
import { Podium } from "./components/Podium";
import Table from "components/list/table";
import { EvtHeader } from "components/header";
import { EmptySection1 } from 'components/empty';


export function BestPerformers() {
  const { quadId } = useParams();

  const activeFilters = {
    quadrimester: quadId,
  };

  const { data: response, isLoading: isDataLoading } = useBestPerformers(
    activeFilters,
    {
      enabled: !!quadId,
    }
  );

  const columns = [
    {
      accessorKey: "rank",
      header: "Rank",
      meta: {
        spanRow: true,
      },
    },
    {
      accessorKey: "reviewee",
      header: "Employee",
      cell: EmployeeCell,
      meta: {
        subRowAccessor: true,
      },
    },
    {
      accessorKey: "total_average_performance",
      header: "Average Performance",
      meta: {
        spanRow: true,
      },
    },
  ];

  // Extract employees array as sub-rows
  const getSubRows = (row) => row.employees;

  if (isDataLoading) {
    return <Loader />;
  }

  const items = response?.data || [];
  const topThree = items.slice(0, 3);
  const rest = items.slice(3);

  return (
    <div className="flex flex-col flex-1 h-full overflow-hidden">
      <EvtHeader
        title="Best Performers"
        info="Top performers based on their average performance rating."
      />
      {
        (response?.data?.length ?? 0) > 0 ? (
          <div className="flex-1 overflow-auto p-4 sm:p-6">
            {topThree.length > 0 && <Podium items={topThree} />}

            {rest.length > 0 && (
              <div>
                <Table
                  data={rest}
                  columns={columns}
                  getSubRows={getSubRows}
                  showHeader={true}
                />
              </div>
            )}
          </div>
        ) : (
          <EmptySection1 />
        )}
    </div>
  );
}
